import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const studentQuizById: ApiFunc<`${typeof API.STUDENT_QUIZ_BY_ID}`, 'get'> = data =>
  instance.get(`${API.STUDENT_QUIZ_BY_ID}`, { params: data })

export const studentQuizAll: ApiFunc<`${typeof API.STUDENT_QUIZ_ALL}`, 'get'> = data =>
  instance.get(API.STUDENT_QUIZ_ALL, { params: data })

export const studentQuizList: ApiFunc<`${typeof API.STUDENT_QUIZ}`, 'get'> = data =>
  instance.get(API.STUDENT_QUIZ, { params: data })

export const studentQuizSave: ApiFunc<`${typeof API.STUDENT_QUIZ_SAVE}`, 'post'> = data =>
  instance.post(API.STUDENT_QUIZ_SAVE, data)

export const studentQuizStart: ApiFunc<`${typeof API.STUDENT_QUIZ_START}`, 'post'> = data =>
  instance.post(API.STUDENT_QUIZ_START, data)

// export const studentQuizSelect: ApiFunc<`${typeof API.STUDENT_QUIZ_SELECT}`, 'get'> = data =>
//   instance.get(API.STUDENT_QUIZ_SELECT, { params: data })

export const studentQuizSubmit: ApiFunc<`${typeof API.STUDENT_QUIZ_SUBMIT}`, 'post'> = data =>
  instance.post(API.STUDENT_QUIZ_SUBMIT, data)

// export const studentQuizSubmitManual: ApiFunc<`${typeof API.STUDENT_QUIZ_SUBMIT_MANUAL}`, 'post'> = data =>
//   instance.post(API.STUDENT_QUIZ_SUBMIT_MANUAL, data)
